import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Box": Box, "@mui/material/LinearProgress": LinearProgress } } });
export default ClientProvider;
